import api from "api";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { actions } from "redux/reducers";
import { ClientContactType, RootState } from "types";
import "./contact-management.scss";

function ContactManagement() {
  const state = useSelector((state: RootState) => state);
  const params: any = useParams();
  const dispatch = useDispatch();

  const getClientContacts = useCallback(() => {
    api.clientContact.getAll(params.clientId)
    .then((data: ClientContactType[]) => 
        dispatch(actions.clientContacts.set(data.filter(x => x.IsDeleted !== true))));
  }, [dispatch, params.clientId]);

  const updateContact = (contactId: number, isActive: boolean) => {
      api.clientContact.updateIsActive(params.clientId, contactId, isActive);
      var contact = state.clientContacts.find(x => x.Id === contactId);
      if (contact) {
        var index = state.clientContacts.indexOf(contact);
        const newState = Object.assign([...state.clientContacts], {
          [index]: {
              ...state.clientContacts[index],
              IsClientContactActive: isActive
          }
        });
        dispatch(actions.clientContacts.set(newState));
      }
  }
  
  const deleteContact = (contactId: number) => {
    api.clientContact.delete(params.clientId, contactId);
    dispatch(actions.clientContacts.set(state.clientContacts.filter(x => x.Id !== contactId)));
}

  useEffect(() => {
    getClientContacts();
  }, [getClientContacts])

  return (
    <div className="contact-management">
      <div id="table">
        <table>
          <thead>
            <tr className="option">
              <th>Name</th>
              <th>Email</th>
              <th>Is Active</th>
              <th></th>
            </tr>
          </thead>
          <tbody id="posts">
            {state.clientContacts.map((item: ClientContactType) => (
              <>
                <tr>
                  <td>{item.Name} {item.Surname}</td>
                  <td>{item.Email}</td>
                  <td>
                    <div className="L_SelectOption">
                      <label className="boxSelction">
                        <input
                          type="checkbox"
                          checked={item.IsClientContactActive}
                          onChange={(event) => {
                            updateContact(item.Id, event.target.checked);
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </td>
                  <td>{!item.IsPrimary && <i className="fas fa-trash-alt" style={{ cursor: "pointer" }} onClick={() => deleteContact(item.Id)}></i>}</td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ContactManagement;